import React from 'react';
import { RetentionROI } from '../../services/analyticsService';

interface Props {
  data: RetentionROI;
}

const PartnerROIChartCard: React.FC<Props> = ({ data }) => {
  const count = data?.new_leads_generated ?? 215;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm flex flex-col justify-between">
      <h2 className="text-sm font-bold text-[#0c1e40] mb-4">Partner ROI and Performance</h2>
      
      {/* Visual Chart Graphic */}
      <div className="flex items-center justify-between px-2 py-3 mb-2">
        {/* Trend line icon */}
        <div className="w-10 h-10 flex items-center justify-center text-[#2563eb]">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2.5}
              d="M3 17l6-6 4 4 8-8"
            />
          </svg>
        </div>

        {/* Mini ascending bar chart */}
        <div className="flex items-end gap-1.5 h-10">
          <div className="w-2.5 h-3 bg-[#1d4ed8] rounded-xs" />
          <div className="w-2.5 h-5 bg-[#1d4ed8] rounded-xs" />
          <div className="w-2.5 h-7 bg-[#1d4ed8] rounded-xs" />
          <div className="w-2.5 h-9 bg-[#1d4ed8] rounded-xs" />
        </div>
      </div>

      {/* Metrics Row */}
      <div className="flex items-center justify-between pt-2">
        <span className="text-xs font-semibold text-gray-700 leading-snug">Policyholder Retention</span>
        <span className="text-2xl font-extrabold text-[#0c1e40] tabular-nums">{count}</span>
      </div>
    </div>
  );
};

export default PartnerROIChartCard;
